import { EncounterFeedType } from './types.js';
export const EncounterFeedEntity = {
    Order: 'order',
    Protocol: 'protocol',
};
export const EncounterTypeToEntity = {
    [EncounterFeedType.ProtocolNavigation]: EncounterFeedEntity.Protocol,
    [EncounterFeedType.ProtocolConsiderationSwitch]: EncounterFeedEntity.Protocol,
    [EncounterFeedType.OrderSent]: EncounterFeedEntity.Order,
    [EncounterFeedType.OrderResulted]: EncounterFeedEntity.Order,
};
//# sourceMappingURL=consts.js.map